let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("krHhg")).then(() => parcelRequire('4Mw8w'));